import React, { memo } from 'react';
import AdminMenuOptimized from './AdminMenuOptimized';

interface AdminLayoutProps {
  children: React.ReactNode;
}

/**
 * Composant AdminLayout optimisé avec React.memo
 * Évite les re-renders inutiles du layout principal
 */
const AdminLayoutOptimized = memo<AdminLayoutProps>(({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminMenuOptimized />
      <div className="pl-64">
        {children}
      </div>
    </div>
  );
});

AdminLayoutOptimized.displayName = 'AdminLayoutOptimized';

export default AdminLayoutOptimized;
